import { render, staticRenderFns } from "./DocumentTreeView.vue?vue&type=template&id=3efa44db"
import script from "./DocumentTreeView.vue?vue&type=script&lang=js"
export * from "./DocumentTreeView.vue?vue&type=script&lang=js"
import style0 from "./DocumentTreeView.vue?vue&type=style&index=0&id=3efa44db&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports